<template>
  <vue-good-table
    v-bind="$attrs"
    v-on="$listeners"
    :pagination-options="mergedPaginationOptions"
  >
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>

    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotProps">
      <slot :name="name" v-bind="slotProps"></slot>
    </template>

    <slot></slot>
  </vue-good-table>
</template>

<script>
// ! Avoid using this component! Use `shared/dashboard-components/table-large` instead.

export default {
  inheritAttrs: false,
  name: 'vue-good-table-wrapper',
  props: {
    paginationOptions: {
      type: Object,
      default: () => ({})
    }
  },

  mounted() {
    console.log('vue-ggod-table',this)
  },  

  computed: {
    mergedPaginationOptions() {
      return {
        ...this.paginationOptions,
        nextLabel: this.$t('actions.next'),
        prevLabel: this.$t('actions.previous'),
        rowsPerPageLabel: this.$t('components.rows_per_page'),
        allLabel: this.$t("components.all"),
        ofLabel: this.$t("components.of")
      };
    }
  }
};
</script>
<style>
.vgt-table th > span {
  white-space: nowrap;
  overflow: hidden;
}
</style>